class PermissionChecker {
  constructor(props) {
    this.userPermissions = props.auth.user.permissions
  }

  // hasPermission(permission) {
  //     return this.userPermissions.includes(permission);
  // }

  hasPermission(permission) {
    if (Array.isArray(permission)) {
      for (let i = 0; i < permission.length; i++) {
        if (this.userPermissions.includes(permission[i])) {
          return true
        }
      }
      return false
    } else {
      return this.userPermissions.includes(permission)
    }
  }
}

export default PermissionChecker
